// =============================================
// File: src/services/planService.js
// =============================================

import axiosInstance from "./axiosInstance";

// Get all membership plans
export const getPlans = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/plans', { params });
    return response;
  } catch (error) {
    throw error;
  }
}

// Get single plan by ID
export const getPlanById = async (id) => {
  try {
    const response = await axiosInstance.get(`/plans/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

// Create new plan
export const createPlan = async (planData) => {
  try {
    const response = await axiosInstance.post('/plans', planData);
    return response;
  } catch (error) {
    throw error;
  }
}

// Update plan
export const updatePlan = async (id, planData) => {
  try {
    const response = await axiosInstance.put(`/plans/${id}`, planData);
    return response;
  } catch (error) {
    throw error;
  }
}

// Delete plan
export const deletePlan = async (id) => {
  try {
    const response = await axiosInstance.delete(`/plans/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

// Get active plans only
export const getActivePlans = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/plans/active', { params });
    return response;
  } catch (error) {
    throw error;
  }
}

// Toggle plan status (activate/deactivate)
export const togglePlanStatus = async (id, status) => {
  try {
    const response = await axiosInstance.patch(`/plans/${id}/status`, { status });
    return response;
  } catch (error) {
    throw error;
  }
}

// Get plan statistics
export const getPlanStats = async (id) => {
  try {
    const response = await axiosInstance.get(`/plans/${id}/stats`);
    return response;
  } catch (error) {
    throw error;
  }
}

// Get plan subscribers/members
export const getPlanSubscribers = async (id, params = {}) => {
  try {
    const response = await axiosInstance.get(`/plans/${id}/subscribers`, { params });
    return response;
  } catch (error) {
    throw error;
  }
}

// Assign plan to customer
export const assignPlanToCustomer = async (planId, customerData) => {
  try {
    const response = await axiosInstance.post(`/plans/${planId}/assign`, customerData);
    return response;
  } catch (error) {
    throw error;
  }
}

// Check service availability for a plan
export const checkServiceAvailability = async (planId, serviceId) => {
  try {
    const response = await axiosInstance.get(`/plans/${planId}/services/${serviceId}/availability`);
    return response;
  } catch (error) {
    throw error;
  }
}

// Use a service from plan
export const useServiceFromPlan = async (planId, usageData) => {
  try {
    const response = await axiosInstance.post(`/plans/${planId}/use-service`, usageData);
    return response;
  } catch (error) {
    throw error;
  }
}

// Get service usage history for a plan
export const getServiceUsageHistory = async (planId, params = {}) => {
  try {
    const response = await axiosInstance.get(`/plans/${planId}/usage-history`, { params });
    return response;
  } catch (error) {
    throw error;
  }
}